export default "__VITE_ASSET__Cw6wkWXN__"